import React from 'react';
import _ from 'lodash';
import '../../css/soldiers.css';

import ListTable from './ListTable';

import columns from '../../json/soldierColumns.json';

import Button from '../../../../core/web/js/button/Button';
import AddButton from '../../../../core/web/js/button/Add';
import EditButton from '../../../../core/web/js/button/Edit';
import DeleteButton from '../../../../core/web/js/button/Delete';
import DownloadButton from '../../../../core/web/js/button/Download';
import ResetButton from '../../../../core/web/js/button/Reset';

import ConfirmPrompt from '../../../../core/web/js/prompt/ConfirmPrompt';
import ErrorMessage from '../../../../core/web/js/message/Error';
import {closeMessage} from '../../../../core/web/js/message/MessageUtil';

import {orderColumns} from '../../../../core/web/js/table/ColumnViewUtil';
import {downloadCSV} from '../../../../core/web/js/table/CsvUtil';


/**
 *
 */
function Soldiers(props){
  const renderer = {
    "move":_renderNumber,
    "fight":_renderNumberSign,
    "shoot":_renderNumberSign,
    "armor":_renderNumber,
    "will":_renderNumberSign,
    "health":_renderNumber,
    "cost":_renderNumber
  };

  return (
    <div className="soldiers">
      <ConfirmPrompt
        confirmDisplay={props.state.confirmDisplay}
        message={props.state.confirmMessage}
        confirmClick={_confirmDeleteClick.bind(this, props, 'confirmDisplay')}
        cancelClick={_cancelConfirmClick.bind(this, props, 'confirmDisplay')}
      />
      <ErrorMessage message={props.state.errorMessage}
        close={closeMessage.bind(this,props,'errorMessage')}
        duration={5000}
      />
      <div className="content">
        <ListTable
          columns={columns}
          rows={props.state.custom}
          stateName={props.stateName}
          state={props.state}
          updateState={props.updateState}
          render={renderer}
        />
      </div>
      {_renderActionPane(props)}
    </div>
  );
}


/**
 *
 */
function _confirmDeleteClick(props){
  console.log('_confirmDeleteClick');
  const selection = props.state.selection[0];
  const custom = _.cloneDeep(props.state.custom).filter(soldier=>soldier.name!==selection);
  props.updateState(props.stateName, {
    "custom": custom,
    "confirmDisplay":"closed",
    "confirmMessage":""
  });
}


/**
 *
 */
function _cancelConfirmClick(props){
  props.updateState(props.stateName, {"confirmDisplay":"closed", "confirmMessage":""});
}


/**
 *
 */
function _renderNumber(data, row){
    return (<div className="number">{data}</div>);
}


/**
 *
 */
function _renderNumberSign(data, row){
  if(data>0){
    return (<div className="number">+{data}</div>);
  }else{
    return (<div className="number">{data}</div>);
  }
}


/**
 *
 */
function _renderActionPane(props){
  if(props.state.addRoster){
    return (
      <div className="actionPane">
        <AddButton type="primary" onClick={_addToCrew.bind(this, props)}>Add To Crew</AddButton>
        <ResetButton onClick={_resetClick.bind(this, props)} />
        <Button onClick={_cancelClick.bind(this, props)}>Cancel</Button>
      </div>
    );
  }else{
    return (
      <div className="actionPane">
        <AddButton type="primary" title="Create Soldier" onClick={_createSoldier.bind(this, props)}>Create</AddButton>
        <EditButton title="Edit Soldier" onClick={_EditSoldier.bind(this, props)}>Edit</EditButton>
        <DeleteButton title="Delete Soldier"onClick={_DeleteSoldier.bind(this, props)}>Delete</DeleteButton>
        <DownloadButton title="Download CSV" onClick={_downloadCSV.bind(this, props)} />
        <ResetButton onClick={_resetClick.bind(this, props)} />
      </div>
    );
  }
}


/**
 *
 */
function _downloadCSV(props){
  let {orderedColumns} = orderColumns(columns, props.state.columnOrder);
  downloadCSV(
    orderedColumns,
    props.state.columnView,
    props.state.custom,
    null,
    props.state.sort,
    null,
    props.state.filter,
    "soldiers"
  );
}


/**
 *
 */
function _createSoldier(props){
  props.updateState('soldier', {
    "createSoldier":_createSoldierSuccess.bind(this, props),
    "cancelCreate":_cancelCreate.bind(this, props)
  });
  window.location = '#soldier';
}


/**
 *
 */
function _createSoldierSuccess(props, data){
  if(data){
    let custom = _.cloneDeep(props.state.custom);
    custom.push(data);

    let state = _.cloneDeep(props.state);
    state.custom = custom;

    let resetStates = [
      {"id":"soldier"},
      {"id":props.stateName, "mixin":state}
    ];
    props.resetMultiple(resetStates);
    window.location = '#' + props.stateName;
  }
}


/**
 *
 */
function _EditSoldier(props){
  if(props.state.selection.length > 0){
    let data = props.state.custom.filter(soldier=>soldier.name===props.state.selection[0])[0];

    props.updateState('soldier', {
      "editSoldier":_editSoldierSuccess.bind(this, props, props.state.selection[0]),
      "cancelCreate":_cancelCreate.bind(this, props),
      ...data
    });
    window.location = '#soldier';

  }else{
    props.updateState(props.stateName, {"errorMessage": "Please select a soldier to edit."})
  }
}


/**
 *
 */
function _editSoldierSuccess(props, oldName, data){
  let custom = _.cloneDeep(props.state.custom).map(soldier=>{
    if(soldier.name===oldName){
      soldier = Object.assign(soldier, data);
    }
    return soldier;
  });

  let state = _.cloneDeep(props.state);
  state.custom = custom;

  let resetStates = [
    {"id":"soldier"},
    {"id":props.stateName, "mixin":state}
  ];
  props.resetMultiple(resetStates);
  window.location = '#' + props.stateName;
}


/**
 *
 */
function _cancelCreate(props){
  props.resetState('soldier');
  window.location = '#' + props.stateName;
}


/**
 *
 */
function _cancelClick(props){
  props.updateState(props.stateName, {'addRoster':null})
  window.location = '#crew';
}


/**
 *
 */
function _addToCrew(props){
  if(_validate(props)){
    if(props.state.addRoster){
      const data = _getData(props);
      props.state.addRoster(data);
    }else{
      throw Error("Missing add captain callback")
    }
  }
}


/**
 *
 */
function _validate(props){
  let message="";
  if(props.state.selection.length===0){
    message = "Please select a soldier.";
  }

  if(message){
    props.updateState(props.stateName, {'errorMessage':message});
    return false;
  }else{
    return true;
  }
}


/**
 *
 */
function _getData(props){
  return _.cloneDeep(props.state.custom.filter(row=>row.name===props.state.selection[0])[0]);
}


/**
 *
 */
function _resetClick(props){
  props.resetState(props.stateName, {"addRoster": props.state.addRoster, "custom": props.state.custom});
}


/**
 *
 */
function _DeleteSoldier(props){
  if(props.state.selection.length > 0){
    console.log('_DeleteSoldier');
    props.updateState(props.stateName, {
      "confirmDisplay":"open",
      "confirmMessage":"Delete " + props.state.selection[0] + "?"
    });
  }else{
    props.updateState(props.stateName, {"errorMessage": "Please select a soldier to delete."})
  }
}

export default Soldiers;
